import { createAction } from 'redux-actions';
import { createRequestActions } from '../utils';
import { INIT, LIST_COUNTRY, ALL_REFERENTIALS } from './referentialsTypes';

export const initReferentials = createAction(INIT);
export const listCountries = createRequestActions(LIST_COUNTRY);
export const allReferentials = createRequestActions(ALL_REFERENTIALS);
